import { observer } from "mobx-react";
import { bool } from "prop-types";
import { useTranslation } from "react-i18next";
import { useEstimateEditorSettings, useEstimateEditorStore, useEstimateStructure } from "@tools";
import { Grid, IconButton, Tooltip } from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";
import { TimelineSections, TimelineUtilization, TimelineBilling } from "./parts";
import useStyle from "./TimelineMenu.style";
import classnames from "classnames";

export const TimelineMenu = observer(({ fullSectionActions, addBorder }) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { visibilityMode } = useEstimateEditorStore();
  const { blockExpansions, isSellerOrClient } = useEstimateEditorSettings();
  const classes = useStyle();

  const {
    useTimelineSections,
    useTimelineUtilization,
    useTimelineBilling,
  } = structure.settings;

  const {
    apply,
    hideTimelineSections,
    hideTimelineUtilization,
    hideTimelineBilling,
  } = structure.visibility;

  const displaySections = useTimelineSections &&
    (!apply || visibilityMode || !hideTimelineSections);
  const displayUtilization = useTimelineUtilization &&
    (!apply || visibilityMode || !hideTimelineUtilization);
  const displayBilling = isSellerOrClient &&
    useTimelineBilling &&
    (!apply || visibilityMode || !hideTimelineBilling);
  const hasExpandedMonths = Boolean(structure.settings.timelineExpandedMonths?.size);

  const handleCollapseGrid = () => {
    if (blockExpansions) return;
    structure.settings.clearTimelineExpandedMonths()
  }

  return <Grid
    item container
    direction="column"
    wrap="nowrap"
    className={classnames(
      classes.root,
      addBorder && classes.border,
      fullSectionActions && classes.expanded,
    )}
  >
    <Tooltip title={t("views.editor.timeline_table.collapse_expanded_periods")}>
      <span className={classes.collapseExpanded}>
        <IconButton
          size="small"
          color="primary"
          disabled={!hasExpandedMonths}
          onClick={handleCollapseGrid}
          aria-label={t("views.editor.timeline_table.collapse_expanded_periods")}
        >
          <ChevronLeft />
        </IconButton>
      </span>
    </Tooltip>
    {
      displaySections &&
      <TimelineSections isFirst />
    }
    {
      displayUtilization &&
      <TimelineUtilization
        isFirst={!displaySections}
      />
    }
    {
      displayBilling &&
      <TimelineBilling
        isFirst={!displaySections && !displayUtilization}
      />
    }
  </Grid>
})

TimelineMenu.propTypes = {
  fullSectionActions: bool,
};
